import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, take } from 'rxjs';

import { Country, LanguageService } from '@spartacus/core';
import { Cart } from '@spartacus/cart/base/root';

import { ConfigurationService } from './configuration.service';
import { BaseStoreService } from './base-store.service';
import { nshiftDetails } from '../models';

@Injectable({
  providedIn: 'root'
})
export class NshiftService {
  private activeLanguage: string;

  constructor(
    private http: HttpClient,
    private configService: ConfigurationService,
    private languageService: LanguageService,
    private baseStoreService: BaseStoreService
  ) {
    this.languageService
      .getActive()
      .pipe(take(1))
      .subscribe((currentLang) => {
        this.activeLanguage = currentLang;
      });
  }

  getNshiftOptions(cart: Cart, postalCode: string, country?: Country): Observable<nshiftDetails> {
    const productTypes = [
      ...new Set(
        cart.entries
          .map((entry) => entry.product?.productGenre?.toLocaleLowerCase())
          .filter((productGenre) => productGenre !== undefined)
      )
    ];
    const productTypesParams = productTypes?.reduce((acc, curr) => ((acc[curr] = true), acc), {});
    const totalVolume = cart.entries.reduce(
      (total, entry) =>
        total + (entry.quantity * entry.product.packVolume),
      0
    );

    country ??= this.baseStoreService.baseStore.deliveryCountries?.[0];

    const config = this.configService.config;
    const url = `${config.nShift.baseUrl}/${config.nShift.checkoutId}`;
    const headers = {
      Authorization: 'Basic ' + config.nShift.token
    };
    const params = {
      currency: cart?.totalPrice?.currencyIso,
      language: this.activeLanguage?.split('_')[0],
      tocountry: country?.isocode,
      tozipcode: postalCode,
      length_cm: cart?.longestProductLength,
      width_cm: cart?.longestProductWidth,
      weight: cart?.totalWeight,
      height_cm: cart?.highestProduct,
      heaviestProductWeight: cart?.heaviestProduct,
      totalProducts: cart.totalProducts,
      cartprice: cart?.totalPrice?.value - cart?.deliveryCost?.value,
      orderType: cart?.orderType?.toLowerCase(),
      freeShippingApplied: cart.deliveryCost?.value === 0 || cart.freeShippingApplied,
      totalVolume: Math.round(totalVolume),
      ...productTypesParams
    };
    return this.http.get<nshiftDetails>(url, { headers: headers, params: params });
  }
}
